import { Spinner } from '@cian/ui-kit/loader';
import * as React from 'react';

import * as styles from './Loader.css';

export function Loader() {
  return (
    <div className={styles['loader']}>
      <Spinner size={20} />
    </div>
  );
}
